var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51218 2.52864C8.77253 2.78899 8.77253 3.2111 8.51218 3.47145L4.33827 7.64536C4.07792 7.90571 3.65581 7.90571 3.39546 7.64536C3.13511 7.38501 3.13511 6.9629 3.39546 6.70255L7.56937 2.52864C7.82972 2.26829 8.25183 2.26829 8.51218 2.52864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.56937 2.52864C7.82972 2.26829 8.25183 2.26829 8.51218 2.52864L12.6861 6.70255C12.9464 6.9629 12.9464 7.38501 12.6861 7.64536C12.4257 7.90571 12.0036 7.90571 11.7433 7.64536L7.56937 3.47145C7.30902 3.2111 7.30902 2.78899 7.56937 2.52864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04078 2.33337C8.40897 2.33337 8.70744 2.63185 8.70744 3.00004V13C8.70744 13.3682 8.40897 13.6667 8.04078 13.6667C7.67259 13.6667 7.37411 13.3682 7.37411 13V3.00004C7.37411 2.63185 7.67259 2.33337 8.04078 2.33337Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrowUp);
export default __webpack_public_path__ + "static/media/line-arrow-up.179e66eade05fcc9eaa8f07bae5896df.svg";
export { ForwardRef as ReactComponent };